<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section">
        <UiContainer max-width="max-w-4xl">
            <div class="grid grid-cols-2 gap-x-12 items-center max-[769px]:grid-cols-1 max-[769px]:gap-x-0 max-[769px]:gap-y-10">
                <div class="max-[769px]:flex max-[769px]:gap-x-2.5 max-[769px]:items-center max-[641px]:flex-col max-[641px]:gap-y-4">
                    <img
                        :src="blok?.image_eu.filename"
                        :alt="blok?.image_eu.alt"
                        class="max-[769px]:max-w-[200px]"
                    >
                    <div class="mt-8 font-londrina-solid text-white  [&>p]:fs-5xl [&>h6]:fs-4xl [&>h6]:leading-[36px] [&>h5]:text-chsc-yellow [&>h5]:text-[88px] [&>h5]:leading-[64px] [&>p]:leading-[36px]">
                        <StoryblokRichText :doc="blok?.claim" />
                    </div>
                </div>
                <div>
                    <div class="global-text">
                        <StoryblokRichText :doc="blok?.description" />
                    </div>
                </div>
            </div>
        </UiContainer>
        <UiContainer>
            <div class="bg-chsc-indigo-500 rounded-[40px] p-12">
                <div class="grid grid-cols-2 gap-x-12 items-center">
                    <div>
                        <div class="text-center font-londrina-solid text-white  [&>h6]:fs-6xl [&>h6]:leading-[48px] [&>*>strong]:text-chsc-yellow [&>h5]:text-[140px] [&>h5]:leading-[120px] [&>p]:leading-[36px]">
                            <StoryblokRichText :doc="blok?.traceability_claim" />
                        </div>
                        <div class="mt-8">
                            <img
                                :src="blok?.traceability_image.filename"
                                :alt="blok?.traceability_image.alt"
                                class="mx-auto"
                            >
                        </div>
                    </div>
                    <div class="[&>p]:font-eb-garamond [&>p]:fs-2xl [&>p]:text-white">
                        <StoryblokRichText :doc="blok?.traceability_text" />
                    </div>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
